import React, { ChangeEvent, useState } from 'react';
import './styles.scss';
import { useAuth } from '../../core/contexts/authContext';
import toast from 'react-hot-toast';

const LoginPage = () => {
  const { login } = useAuth();

  const [email, setEmail] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [validationError, setValidationError] = useState<string>('');

  const validateEmailInput = (
    value: string
  ): { isValid: boolean; error: string } => {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return {
        isValid: false,
        error: 'Email is required',
      };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(trimmedValue)) {
      return {
        isValid: true,
        error: '',
      };
    } else {
      return {
        isValid: false,
        error: 'Enter a valid email address',
      };
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setEmail(value);

    if (validationError) {
      setValidationError('');
    }
  };

  const handleLogin = async () => {
    const validation = validateEmailInput(email);

    if (!validation.isValid) {
      setValidationError(validation.error);
      return;
    }

    setValidationError('');

    try {
      setIsLoading(true);

      await login({
        email: email.trim(),
      });

      setIsLoading(false);
    } catch (error) {
      console.error('Login error:', error);
      setValidationError('Login error, please try again');
      toast.error('Login error, please try again');
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  const validation = validateEmailInput(email);
  const isFormValid = validation.isValid;

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="image-section">
          <div className="image-overlay">
            <img
              src="/images/login-preview.png"
              className="login-preview-image"
              alt="login-preview"
            />
          </div>
        </div>

        <div className="form-section">
          <div className="content">
            <h1 className="title">HOW DOES YOUR TEAM RANK?</h1>

            <p className="subtitle">
              GET READY TO RISE TO THE CHALLENGE AND TRACK YOUR TEAM'S PROGRESS
            </p>

            <p className="description">
              Log in with your email address to see how you, your team, and your
              competitors are doing during The Playoffs. Rank against other
              challengers and see how close your team is to securing your
              rewards and stacking your prizes.
            </p>

            <div className="form-container">
              <div className="input-group">
                <label htmlFor="email" className="input-label">
                  ENTER YOUR EMAIL ADDRESS
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  placeholder="example@email.com"
                  required
                  className={`input-field ${validationError ? 'input-error' : ''}`}
                  disabled={isLoading}
                />
                {validationError && (
                  <div className="error-message">{validationError}</div>
                )}
              </div>

              <button
                onClick={handleLogin}
                disabled={isLoading || !isFormValid}
                className={`login-button ${isLoading || !isFormValid ? 'disabled' : ''} ${isLoading ? 'loading' : ''}`}
                type="button"
              >
                {isLoading ? 'LOGGING IN...' : 'LOG IN'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
